import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const Cell = styled.td`
  padding: 1rem;
  border: none;
`

export const Row = styled.tr.attrs({ role: 'columnrow' })`
  height: ${({ isOpen }) => (isOpen ? 'auto' : '0')};
  font-family: ${themeGet('fontFamily')};
  cursor: ${({ isTitleRow }) => (isTitleRow ? 'pointer' : 'auto')};
`

export const StyledTd = styled.td`
  border-bottom: none !important;
  padding: 0;
`

export const Table = styled.table`
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
`

export const TableWrapper = styled.div.attrs(({ isOpen, maxHeight }) => ({
  height: isOpen ? `${maxHeight}px` : 0,
}))`
  height: ${({ height }) => height};
  overflow: hidden;
  transition: height 0.2s ease-in-out;
`

export const TitleCell = styled.td.attrs(props => ({
  borderBottom: props.isOpen
    ? `2px solid ${themeGet('colors.paleGray')(props)}`
    : `2px solid ${themeGet('colors.white')(props)}`,
}))`
  padding: 1rem 0 1.125rem;
  border: 2px solid ${themeGet('colors.paleGray')};
  border-bottom: ${({ borderBottom }) => borderBottom} !important;
  transition: all 0.2s ease;
  position: relative;

  .caret-icon-small {
    position: absolute;
    top: 14px;
    right: 20px;
    transform: rotate(${({ isOpen }) => (isOpen ? '180deg' : '0deg')});
  }

  &:hover {
    border-color: ${themeGet('colors.beaconGray')} !important;
    transition: all 0.2s ease;

    .caret-icon-small {
      color: ${themeGet('colors.darkBlue')};
      transition: all 0.2s ease;
    }
  }
`
